/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as _ from 'lodash'
import { MINIMUM_WITHDRAW, WithdrawInfoPopup, WithdrawPreviousBank } from '../configs/B2C.config';
import { withdrawalOrder } from '../services/depositWithdrawalService';
import { getApniIFSCCodeDetails } from '../services/xoroService';
import { staticContentsImagePath as BASE_IMAGE_PATH } from "../configs/const";
import WithdrawBankDropdownMenu from './sub_components/withdrawBankDropdownMenu';
// import { getDepositBonusOffers, getIFSCCodeDetails, getManualWithdrawal, getMyPreviousBank, getXoroActiveProviderData, getXoroDataNew } from '../services/xoroService';


class WalletWithdrawInnerComp extends Component {
    csvLink = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            utr: null,
            ss: {},
            buttonLoader: false,
            cryptoNetwork:"",
            accountHolderName: "",
            accountNumber: "",
            iFSCCode: "",
            ifscBankDetails: null,
            beneficiaryId: "",
            xoropeOption: ["Bank", "Paytm", "PhonePe", "GooglePay", "Upi", "Nagad", "Bkash", "Rocket", "Upay", "WhatsApp"],
            paymentModeSel: { "ICEPE": "IMPS", "XIENPAY": "PG", "WIZPAY": "UPI", "UNICON": "IM", "PFPAY": "IMPS", "NEWWIZPAY": "UPI", "NEWXIENPAY": "PG", "PAYATOM": "WALLET", "CRYPTIX": "PG", "TRUSTPAY": "PG" },
            selectedPaymentModeOption: '',
            withdrawApiBeneficiary: ["XOROPE", "CRYPTIX", "ALPHAPAY", "PAYATOM", "WPAY"],
            cryptotypes: ["CRYPTIX", "ALPHAPAY"],
            SsfileName: "",
            SsFileBase64: "",
            showPreviewModal: false,
            previewImage: "",
            agreeTerms: false,
            showTermsModal: false,
            selectedLang: "EN",
        };
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps) {
        if (prevProps.activeBeneficiaryType !== this.props.activeBeneficiaryType) {
            this.setState({
                utr: null,
                accountHolderName: "",
                accountNumber: "",
                iFSCCode: "",
                ifscBankDetails: null,
                beneficiaryId: "",
                cryptoNetwork: ""
            });
        }
    }

    onChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value });
    }


    onSubmitClick() {
        if (this.props.activeBeneficiaryType !== "WITHDRAW_CRYPTO"){
            if(!(!!this.state.accountHolderName && this.state.accountHolderName.length > 1)) {
                this.props.notify(`Provide ${(this.props.activeBeneficiaryType === 'WITHDRAW_BANK' || this.props.activeBeneficiaryType === 'WITHDRAW_PKRBANK') ? 'Account Holder Name' : 'Holder Name'}`, "error");
                return false;
            }
        } else if (!(!!this.state.cryptoNetwork && this.state.cryptoNetwork.length > 1)) {
            this.props.notify(`Provide Network`, "error");
            return false;
        }
        if (!(!!this.state.accountNumber && this.state.accountNumber.length > 4)) {
            this.props.notify(`Provide Valid ${this.props.activeBeneficiaryType === 'WITHDRAW_PKRBANK' ? "IBAN Number" : this.props.activeBeneficiaryType === 'WITHDRAW_BANK' ? 'Account Number' : 'Wallet ID/Number'}`, "error");
            return false;
        }
        if (this.props.activeBeneficiaryType === 'WITHDRAW_BANK' && !(!!this.state.iFSCCode && this.state.iFSCCode.length > 4)) {
            this.props.notify("Provide Valid IFSC Code", "error");
            return false;
        }
        if (this.props.activeBeneficiaryType === 'WITHDRAW_PKRBANK' && !(!!this.state.iFSCCode)) {
            this.props.notify("Provide Valid Bank Name", "error");
            return false;
        }
        if (!!this.props.activePaymentOption && !!this.props.activePaymentOption.gatewayProvider && !!this.props.activePaymentOption.gatewayProvider.paymentMode && this.props.activePaymentOption.gatewayProvider.paymentMode.length > 1 && (this.state.selectedPaymentModeOption === '')) {
            this.props.notify("Select payment mode", "error");
            return false;
        }
        // if (!(!!this.props.amount && parseFloat(this.props.amount) >= this.props.MINIMUM_WITHDRAW && parseFloat(this.props.amount) <= parseFloat(this.props.balance))) {
        //     this.props.notify("Enter Valid Amount", "error");
        //     return false;
        // }

        if (WithdrawInfoPopup) {
            this.openWithdrawInfoPopup();
        } else {
            this.onWithdrawalClickAPI()
        }
    }


    openWithdrawInfoPopup() {
        this.props.MySwal.fire({
            title: "<strong>Withdrawal Info</strong>",
            icon: "",
            html: `
      <div class="">
        <div>
          <h3>
            <span style="color: rgb(0, 168, 133);">
              <span style="font-size: 20px;">Thanks for withdrawal Request</span> 
            </span>
          </h3>
          <p class="mb-0 text-black">आपने जो withdrawal request डालì है, वह आपके बैंक खाते में 1 मिनट से 60 मिनट के अंदर आ जाएगा। minimum 1 min maximum 60 min.</p>
          <p class="text-light-grey">--------------------------------------------------------</p>
          <p class="mb-0 text-black">The withdrawal request you have placed will be credited to your bank account within 1 minutes to 60 minutes. Minimum 1 min maximum 60 min.</p>
          <p class="text-light-grey">--------------------------------------------------------</p>
          <p class="text-black">మీరు చేసిన ఉపసంహరణ అభ్యర్థన 1 నిమిషాల నుండి 60 నిమిషాలలోపు మీ బ్యాంక్ ఖాతాకు క్రెడిట్ చేయబడుతుంది.  కనిష్టంగా 1 నిమిషాలు గరిష్టంగా 60 నిమిషాలు.</p>
        </div>
      </div>
      `,
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: 'Agree'
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                this.onWithdrawalClickAPI();
            }
        });
    }

    onWithdrawalClickAPI() {
        const self = this;
        let body = {
            operatorId: this.props.operatorId,
            username: this.props.userId,
            amount: this.props.amount,
            paymentMode: this.props.activePaymentOption.gatewayProvider.gatewayProvider === 'XOROPE' ? this.props.gateWay : (!!this.props.activePaymentOption.gatewayProvider.paymentMode ? (this.props.activePaymentOption.gatewayProvider.paymentMode.length === 1 ? this.props.activePaymentOption.gatewayProvider.paymentMode[0] : this.state.selectedPaymentModeOption) : ''),//this.state.xoropeOption.includes(this.props.gateWay) ? this.props.gateWay : this.state.paymentModeSel[this.props.gateWay],
            accountName: this.state.accountHolderName,
            accountNumber: this.state.accountNumber,
            routingInformation:
                (this.props.gateWay === 'Bank' || this.props.activeBeneficiaryType === 'WITHDRAW_PKRBANK' || !this.state.xoropeOption.includes(this.props.gateWay))
                    ? this.state.iFSCCode
                    : '',
            gatewayProvider: this.props.gatewayProvider,
            beneficiaryId: this.state.beneficiaryId,
            SsfileName: this.state.SsfileName,
            SsFileBase64: this.state.SsFileBase64,
        };
        // document.getElementById("btnWithdraw").disabled = true;
        this.setState({ buttonLoader: true }, () => {
            withdrawalOrder(body)
                .then((res) => {
                    if (!!res) {
                        if (!!res.url) {
                            window.location.href = res.url;
                        } else if (!!res.withdrawId) {
                            self.props.MySwal.fire({
                                title: 'Success.',
                                text: `We have recevied your withdraw request. withdrawId: ${res.withdrawId}. For any support, contact our chat executive or whatsapp.`,
                                icon: 'success',
                                confirmButtonText: 'OK',
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    window.location.href = "/home";
                                } else {
                                    self.setState(
                                        {
                                            bankName: "",
                                            accountHolderName: "",
                                            accountNumber: "",
                                            iFSCCode: "",
                                            amount: 0,
                                            buttonLoader: false,
                                            beneficiaryId: ""
                                        }
                                    );
                                }
                            })
                        } else {
                            self.props.notify(
                                res.exception.message,
                                "error"
                            );
                            self.setState({ buttonLoader: false });

                        }
                    }
                })
                .catch((error) => {
                    self.props.notify(error, "error");
                    self.setState({ buttonLoader: false });
                });
        })
    }


    getIFSCCodeDetailsFromCode(ifsccode) {
        if (!ifsccode) {
            return false;
        }
        const self = this;
        this.setState({
            ifscBankDetails: null
        }, () => {
            //   xoroService.
            getApniIFSCCodeDetails(ifsccode).then((res) => {
                if (!!res) {
                    if(!!res.isSuccess){
                        self.setState({ ifscBankDetails: res.data });
                    } else {
                        self.props.notify(res.exception.message, "error");
                    }
                }
            }).catch((error) => {
                self.props.notify(error, "error");
            });
        })
    }


    onIFSCBlur() {
        if (!!this.state.iFSCCode && this.state.iFSCCode.length === 11 && (this.props.activePaymentOption?.gatewayProvider?.gatewayProvider !== "XOROPE" || this.props.gateWay === "Bank")) {
            this.getIFSCCodeDetailsFromCode(this.state.iFSCCode);
        } else {
            this.setState({
                ifscBankDetails: null
            })
        }
    }

    onUsePreviousBankClick(itmm) {
        this.setState({ accountHolderName: itmm.accountHolderName, accountNumber: itmm.accountNumber, iFSCCode: itmm.ifscCode.trim(), beneficiaryId: itmm.beneficiaryId, cryptoNetwork: itmm.network }, () => {
            if(itmm.accountType === "WITHDRAW_BANK"){
                this.getIFSCCodeDetailsFromCode(itmm.ifscCode)
            }
        })
    }

    selectFile(e) {
        const file = e.target.files[0];
        if (!file) return;

        const maxSize = 2 * 1024 * 1024;

        if (file.size > maxSize) {
            this.props.notify("File size should not exceed 2MB", "error");

            e.target.value = null;
            this.setState({ SsfileName: "", SsFileBase64: "", previewImage: "" });
            return;
        }


        // Store file name
        const fileName = file.name;

        // Preview URL (for UI)
        const previewUrl = URL.createObjectURL(file);

        this.setState({
            SsfileName: fileName,
            previewImage: previewUrl
        });

        // Convert to Base64
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64String = reader.result.split(",")[1];

            this.setState({
                SsFileBase64: base64String
            });
        };

        reader.readAsDataURL(file);
    }

    onCheckboxChange(e) {
        const checked = e.target.checked;
        if (checked) {
        this.setState({
            showTermsModal: true,
            selectedLang: "EN"
        });
        } else {
            this.setState({
                agreeTerms: false
            });
        }
    }

    render() {
        const onlyAlphaNumeric = /[0-9a-zA-Z]+/g;
        console.log('activePaymentOption', this.props.activePaymentOption)
        return (
            <>

                {this.props.gateWay === 'WhatsApp' ?
                    <>
                        {/* Whatsapp  payment Start */}
                        <div className="payment-icon-box-container">
                            <div className="payment-icon-box">
                                <div className='align-items-center d-flex justify-content-between'>
                                    <div className='align-items-center d-flex'>
                                        {/* <img src={`${BASE_IMAGE_PATH}/casino/banner/loginimages/depositicon/${this.props.iconPath}`} alt={`${this.props.gateWay} Logo`} className="payment-method-logo" /> */}
                                        <h4>{this.props.displayName}</h4>
                                    </div>
                                    <div>

                                    </div>
                                </div>
                                {/* <div className='payment-details-box row'>
                                    <div className='col-12 col-sm-8 col-md-8'>
                                        <div className='mt-1'>Click WhatsApp to withdraw instantly - available 24x7.</div>
                                    </div>
                                    <div className='col-12 col-sm-4 col-md-4 whatsapp_btn_right'>
                                        <img className='' src={`${BASE_IMAGE_PATH}/casino/wallet/whatsapp-iw.png`} alt='' onClick={() => { window.open(`https://wa.me/+${this.props.activePaymentOption?.gatewayProvider?.whatsappData[0]?.mobileNumber}`, "_blank") }}/>
                                    </div>
                                </div> */}
                                <>
                                    <div className='cursor payment-details-box row' onClick={() => { window.open(`https://wa.me/+${this.props.activePaymentOption?.gatewayProvider?.whatsappData[0]?.mobileNumber}`, "_blank") }} >
                                        <div className=''>
                                            <div className='whatsapp_text_iw_id'>Click WhatsApp to deposit instantly - available 24x7.</div>
                                        </div>
                                    </div>
                                    <div className='cursor whatsapp_btn_right_iw_id' onClick={() => { window.open(`https://wa.me/+${this.props.activePaymentOption?.gatewayProvider?.whatsappData[0]?.mobileNumber}`, "_blank") }}>
                                        <img className='whatsapp-id-iw' src={`${BASE_IMAGE_PATH}/casino/wallet/whatsapp-iw.png`} alt='' onClick={() => { window.open(`https://wa.me/+${this.props.activePaymentOption?.gatewayProvider?.whatsappData[0]?.mobileNumber}`, "_blank") }} />
                                    </div>
                                </>
                            </div>
                        </div>
                        {/* Whatsapp  payment End */}
                    </>
                    :
                    <>
                        {/* Other payment Start */}
                        <div className="payment-icon-box-container">
                            <div className="payment-icon-box">
                                <div className='align-items-center d-flex justify-content-between'>
                                    <div className='align-items-center'>
                                        {/* <img src={`${BASE_IMAGE_PATH}/casino/banner/loginimages/depositicon/${this.props.iconPath}`} alt={`${this.props.gateWay} Logo`} className="payment-method-logo" /> */}
                                        <h4>{this.props.displayName}</h4>
                                        <span>{this.props.caption}</span>
                                    </div>
                                    <div>
                                        {WithdrawPreviousBank && this.props.amount > 0 && 
                                        <WithdrawBankDropdownMenu 
                                            // array={this.props.previousBankDetails.filter((itm) => ((this.state.withdrawApiBeneficiary.includes(this.props.activePaymentOption?.gatewayProvider?.gatewayProvider)) && this.props.gateWay !== "Bank") ? itm.accountType.includes("WITHDRAW_UPI") : itm?.accountType?.includes("WITHDRAW_BANK"))} 
                                            wholeArray={this.props.previousBankDetails} 
                                            onUsePreviousBankClick={(itmm) => this.onUsePreviousBankClick(itmm)} 
                                            previousBankDetailsBtnLdr={this.props.previousBankDetailsBtnLdr} 
                                            notify={this.props.notify} 
                                            updateArray={this.props.updatePreviousBankDetails} 
                                            gatewayProvider={this.props.gatewayProvider} 
                                            gateway={this.props.gateWay} 
                                            MySwal={this.props.MySwal} 
                                            withdrawApiBeneficiary={this.state.withdrawApiBeneficiary} 
                                            cryptotypes={this.state.cryptotypes}
                                            activeBeneficiaryType={this.props.activeBeneficiaryType}
                                            ></WithdrawBankDropdownMenu>}
                                    </div>
                                </div>

                                <div className="row manual-container-qr payment-details-box">
                                    <div className="col-12 col-sm-12 col-md-12">
                                        <div className='row'>
                                            {(!!this.props.activeBeneficiaryType && this.props.activeBeneficiaryType === "WITHDRAW_CRYPTO") ?
                                                <div className='col-12 col-sm-3 col-md-3'>
                                                    <label htmlFor="inputPassword5" className="form-label">Network:</label>
                                                    <input disabled className="form-control" type="text" placeholder="Enter network" aria-label="Disabled input example" name='cryptoNetwork' value={this.state.cryptoNetwork} onChange={(e) => this.onChange(e)}></input>
                                                </div>
                                                :
                                                <div className='col-12 col-sm-3 col-md-3'>
                                                    <label htmlFor="inputPassword5" className="form-label">{(!!this.props.activeBeneficiaryType && (this.props.activeBeneficiaryType === 'WITHDRAW_BANK' || this.props.activeBeneficiaryType === 'WITHDRAW_PKRBANK')) ? 'Account Holder Name' : 'Holder Name'}:</label>
                                                    <input disabled className="form-control" type="text" placeholder={`Enter ${(!!this.props.activeBeneficiaryType && (this.props.activeBeneficiaryType === 'WITHDRAW_BANK' || this.props.activeBeneficiaryType === 'WITHDRAW_PKRBANK')) ? 'Account Holder Name' : 'Holder Name'}`} aria-label="Disabled input example" name='accountHolderName' value={this.state.accountHolderName} onChange={(e) => this.onChange(e)}></input>
                                                </div>
                                            }
                                            <div className='col-12 col-sm-3 col-md-3'>
                                                <label htmlFor="inputPassword5" className="form-label">{(!!this.props.activeBeneficiaryType && this.props.activeBeneficiaryType === "WITHDRAW_CRYPTO") ? 'Crypto Address' : ((!!this.props.activeBeneficiaryType && this.props.activeBeneficiaryType === 'WITHDRAW_PKRBANK' ? 'IBAN Number' : !!this.props.activeBeneficiaryType && this.props.activeBeneficiaryType === 'WITHDRAW_BANK' ? 'Account Number' : 'Wallet ID/Number'))}:</label>
                                                <input disabled className="form-control" type="text" placeholder={`Enter ${(!!this.props.activeBeneficiaryType && this.props.activeBeneficiaryType === "WITHDRAW_CRYPTO") ? 'Crypto Address' : (!!this.props.activeBeneficiaryType && this.props.activeBeneficiaryType === 'WITHDRAW_PKRBANK' ? 'IBAN Number' : !!this.props.activeBeneficiaryType && this.props.activeBeneficiaryType === 'WITHDRAW_BANK' ? 'Account Number' : 'Wallet ID/Number')}`} aria-label="Disabled input example" name='accountNumber' value={this.state.accountNumber} onChange={(e) => this.onChange(e)}></input>
                                            </div>

                                            {(!!this.props.activeBeneficiaryType && this.props.activeBeneficiaryType === 'WITHDRAW_BANK') &&
                                                <div className='col-12 col-sm-3 col-md-3'>
                                                    <label htmlFor="inputPassword5" className="form-label">IFSC Code:</label>
                                                    <input disabled type="text" id="disabledTextInput" className="form-control" placeholder="Enter IFSC Code" name='iFSCCode' value={this.state.iFSCCode} onChange={(e) => this.onChange(e)} onBlur={() => this.onIFSCBlur()}></input>
                                                    {!!this.state.ifscBankDetails && Object.keys(this.state.ifscBankDetails).length > 0 &&
                                                        <label className="ifsc-bank-details">{this.state.ifscBankDetails.bank}-{this.state.ifscBankDetails.branch}-{this.state.ifscBankDetails.district}</label>
                                                    }
                                                </div>
                                            }
                                            {(!!this.props.activeBeneficiaryType && this.props.activeBeneficiaryType === 'WITHDRAW_PKRBANK') &&
                                                <div className='col-12 col-sm-3 col-md-3'>
                                                    <label htmlFor="inputPassword5" className="form-label">Bank Name:</label>
                                                    <input disabled type="text" id="disabledTextInput" className="form-control" placeholder="Enter Bank Name" name='iFSCCode' value={this.state.iFSCCode} onChange={(e) => this.onChange(e)} onBlur={() => this.onIFSCBlur()}></input>
                                                    {!!this.state.ifscBankDetails && Object.keys(this.state.ifscBankDetails).length > 0 &&
                                                        <label className="ifsc-bank-details">{this.state.ifscBankDetails.bank}-{this.state.ifscBankDetails.branch}-{this.state.ifscBankDetails.district}</label>
                                                    }
                                                </div>
                                            }
                                            <div className='col-12 col-sm-3 col-md-3'>
                                                <label htmlFor="inputPassword5" className="form-label">Amount:</label>
                                                <input type="text" id="disabledTextInput" className="form-control" placeholder="" disabled value={this.props.amount}></input>
                                            </div>


                                            {
                                                !!this.props.activeBeneficiaryType && this.props.activeBeneficiaryType === "WITHDRAW_CRYPTO" &&
                                                <>
                                                    <div className='col-12 col-sm-3 col-md-3'>
                                                        <label htmlFor="inputPassword5" className="form-label">Conversion Rate:</label>
                                                        <input className="form-control" type="text" aria-label="Disabled input example" disabled value={this.props?.activePaymentOption.gatewayProvider.conversionRate}></input>
                                                    </div>
                                                    <div className='col-12 col-sm-3 col-md-3'>
                                                        <label htmlFor="inputPassword5" className="form-label">Withdraw Amount in Crypto:</label>
                                                        <input className="form-control" type="text" aria-label="Disabled input example" disabled value={!!this.props.amount ? ((this.props.amount / this.props?.activePaymentOption.gatewayProvider.conversionRate).toFixed(8)) : ''}></input>
                                                    </div>
                                                    {this.props.pgName === "Crypto" && this.props.gatewayProvider === "XOROPE" && <div className='col-12 col-sm-3 col-md-3'>
                                                        <label htmlFor="inputPassword5" className="form-label">QR Code:</label>
                                                        <input className="form-control" type="file" aria-label="Disabled input example" accept=".jpg,.jpeg,.png" name="SsfileName" onChange={(e) => this.selectFile(e)}></input>
                                                        <small className="form-text text-muted">
                                                            Only .jpg, .jpeg, .png files allowed.
                                                        </small>
                                                    </div>}
                                                </>
                                            }
                                            {
                                                !!this.props.activePaymentOption && !!this.props.activePaymentOption.gatewayProvider && !!this.props.activePaymentOption.gatewayProvider.paymentMode && this.props.activePaymentOption.gatewayProvider.paymentMode.length > 1 &&
                                                <>
                                                    <div className='col-12 col-sm-3 col-md-3'>
                                                        <label htmlFor="inputPassword5" className="form-label">Payment mode:</label>
                                                        <select className="form-control" name='selectedPaymentModeOption' value={this.state.selectedPaymentModeOption} onChange={(e) => this.setState({ selectedPaymentModeOption: e.target.value, })}>
                                                            <option value={''}> Select </option>
                                                            {
                                                                this.props.activePaymentOption.gatewayProvider.paymentMode.map((opttt, inx) => {
                                                                    return (
                                                                        <option value={opttt} key={opttt}>{opttt}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </>
                                            }

                                            {this.props.pgName !== "Crypto" && <div className={`col-12 col-sm-3 col-md-3 ${this.props.gateWay === 'Bank' ? 'mt-2' : 'mt-4'}`}>
                                                <div className="mt-1">
                                                    <button className="btn btn-payment-submit" disabled={!this.state.beneficiaryId || this.state.buttonLoader} onClick={() => this.onSubmitClick()}>
                                                        {this.state.buttonLoader &&
                                                            <svg className="spinner mr-2" viewBox="0 0 50 50">
                                                                <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5" style={{ stroke: '#82aadc' }}></circle>
                                                            </svg>}
                                                        Withdraw
                                                    </button>
                                                </div>
                                            </div>}
                                            {this.props.activeBeneficiaryType === "WITHDRAW_CRYPTO" && this.props.pgName === "Crypto" && this.props.gatewayProvider === "XOROPE" && <div className="col-12 col-sm-3 col-md-3 mt-4">
                                                {this.state.previewImage && (
                                                    <button
                                                        className="btn btn-payment-submit"
                                                        onClick={() => this.setState({ showPreviewModal: true })}
                                                    >
                                                        Preview
                                                    </button>
                                                )}
                                            </div>}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        {/* Other payment End */}
                    </>
                }
               {this.state.showPreviewModal && (
                <>
                    <div
                        className="modal fade show"
                        style={{ display: "block" }}
                        tabIndex="-1"
                        role="dialog"
                    >
                        <div className="modal-dialog modal-md modal-dialog-scrollable modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Crypto Withdrawal Details</h5>
                                    <button
                                        type="button"
                                        className="close"
                                        onClick={() => this.setState({ showPreviewModal: false })}
                                    >
                                        ×
                                    </button>
                                </div>

                                <div className="modal-body">
                                    <div className="container-fluid">
                                        <div className="row mb-3 align-items-center">
                                            <div className="text-center col-12">
                                                <img
                                                    src={this.state.previewImage}
                                                    alt="QR"
                                                    style={{ maxWidth: "200px", maxHeight: "140px" }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-5"><strong>Wallet Address:</strong></div>
                                            <div className="col-7">{this.state.accountNumber}</div>
                                        </div>

                                        <div className="row mb-2">
                                            <div className="col-5"><strong>Network:</strong></div>
                                            <div className="col-7">{this.state.cryptoNetwork}</div>
                                        </div>

                                        <div className="row mb-2">
                                            <div className="col-5"><strong>Entered Amount (Fiat):</strong></div>
                                            <div className="col-7">{this.props.amount}</div>
                                        </div>

                                        <div className="row mb-2">
                                            <div className="col-5"><strong>Conversion Rate:</strong></div>
                                            <div className="col-7">
                                                {this.props?.activePaymentOption?.gatewayProvider?.conversionRate}
                                            </div>
                                        </div>

                                        <div className="row mb-2">
                                            <div className="col-5"><strong>Final Amount (Crypto):</strong></div>
                                            <div className="col-7">
                                                {
                                                    this.props.amount && this.props?.activePaymentOption?.gatewayProvider?.conversionRate
                                                        ? (this.props.activePaymentOption.gatewayProvider.conversionRate / this.props.amount).toFixed(8)
                                                        : ''
                                                }
                                            </div>
                                        </div>

                                        <div className="row mt-3">
                                            <div className="col-12">
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        id="agreeTerms"
                                                        checked={this.state.agreeTerms}
                                                        onChange={(e) => this.onCheckboxChange(e)}
                                                    />
                                                    <div className="form-check-label" htmlFor="agreeTerms">
                                                        <span>I have read and agree to the <a className='text-primary' onClick={() => {this.setState({showTermsModal : true, showPreviewModal: false})}}>Terms & Conditions</a></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <div className="">
                                        <div className="">
                                            <button type="button" onClick={() => {this.setState({showPreviewModal: false, agreeTerms: false})}} className="btn btn-outline-danger waves-effect mx-auto d-inline" data-dismiss="modal">Cancel</button>
                                            <button type="button" disabled={this.state.buttonLoader || !this.state.agreeTerms} onClick={() => this.onWithdrawalClickAPI()} className="payment-add-btn select-acc-btn ml-2" data-dismiss="modal">Withdraw</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-backdrop fade show"></div>
                </>
                )}
                {this.state.showTermsModal && (
                    <>
                        <div
                            className="modal fade show"
                            style={{ display: "block" }}
                            tabIndex="-1"
                        >
                            <div className="modal-dialog modal-md modal-dialog-scrollable modal-dialog-centered">
                                <div className="modal-content">

                                    {/* Header */}
                                    <div className="modal-header">
                                        <h5 className="modal-title">Terms & Conditions</h5>
                                        <button
                                            className="close"
                                            onClick={() => this.setState({ showTermsModal: false, agreeTerms: false, showPreviewModal: true })}
                                        >
                                            ×
                                        </button>
                                    </div>

                                    {/* Language Switch Buttons */}
                                    <div className="d-flex align-items-center justify-content-center px-3 pt-2">
                                        <button
                                            className={`btn btn-sm mr-2 ${this.state.selectedLang === "EN" ? "btn place-bet-btn rulesselected" : "btn place-bet-btn"}`}
                                            onClick={() => this.setState({ selectedLang: "EN" })}
                                        >
                                            English
                                        </button>

                                        <button
                                            className={`btn btn-sm ${this.state.selectedLang === "HI" ? "btn place-bet-btn rulesselected" : "btn place-bet-btn"}`}
                                            onClick={() => this.setState({ selectedLang: "HI" })}
                                        >
                                            हिंदी
                                        </button>
                                    </div>

                                    {/* Content */}
                                    <div className="modal-body">
                                        <div className="container-fluid">
                                            {this.state.selectedLang === "EN" ? (
                                                <ol>
                                                    <li>By proceeding with the crypto withdrawal, you agree to carefully verify your wallet address and QR code before submitting the request.</li>
                                                    <li>The system will convert the entered amount into cryptocurrency based on the conversion rate at the time of submission.</li>
                                                    <li>You are solely responsible for providing the correct wallet address and uploading the accurate QR code.</li>
                                                    <li>Once the withdrawal request is processed, it cannot be reversed or modified.</li>
                                                    <li>If the payment is sent to an incorrect or invalid wallet address provided by you, the company will not be responsible for any loss of funds.</li>
                                                    <li>In case you do not receive the payment due to incorrect details submitted by you, the company holds no liability.</li>
                                                    <li>Please ensure all details are reviewed and verified before confirming the withdrawal request.</li>
                                                </ol>
                                            ) : (
                                                <ol>
                                                    <li>क्रिप्टो विड्रॉल प्रक्रिया आगे बढ़ाने से पहले, कृपया रिक्वेस्ट सबमिट करने से पहले अपने वॉलेट एड्रेस और QR कोड को ध्यानपूर्वक सत्यापित करें।</li>
                                                    <li>आपके द्वारा दर्ज की गई राशि को सबमिशन के समय उपलब्ध कन्वर्ज़न रेट के अनुसार क्रिप्टोकरेंसी में परिवर्तित किया जाएगा।</li>
                                                    <li>सही वॉलेट एड्रेस प्रदान करना और सही QR कोड अपलोड करना पूरी तरह आपकी जिम्मेदारी है।</li>
                                                    <li>एक बार विड्रॉल रिक्वेस्ट प्रोसेस हो जाने के बाद, इसे न तो बदला जा सकता है और न ही रिवर्स किया जा सकता है।</li>
                                                    <li>यदि आपके द्वारा दिए गए गलत या अमान्य वॉलेट एड्रेस पर भुगतान भेज दिया जाता है, तो कंपनी किसी भी प्रकार के फंड लॉस के लिए जिम्मेदार नहीं होगी।</li>
                                                    <li>यदि आपके द्वारा दी गई गलत जानकारी के कारण आपको भुगतान प्राप्त नहीं होता है, तो कंपनी की कोई जिम्मेदारी नहीं होगी।</li>
                                                    <li>कृपया विड्रॉल रिक्वेस्ट कन्फर्म करने से पहले सभी विवरणों को ध्यानपूर्वक जांच लें और सत्यापित करें।</li>
                                                </ol>
                                            )}
                                        </div>
                                    </div>

                                    {/* Footer */}
                                    <div className="modal-footer">
                                        <button
                                            className="btn btn-secondary"
                                            onClick={() => this.setState({ showTermsModal: false, agreeTerms: false, showPreviewModal: true })}
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            className="btn btn-success"
                                            onClick={() => this.setState({ showTermsModal: false, showPreviewModal: true, agreeTerms: true })}
                                        >
                                            I Agree
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="modal-backdrop fade show"></div>
                    </>
                )}
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(WalletWithdrawInnerComp);